import { useSearchParams } from "react-router-dom";

export type SortDir = "asc" | "desc";

export function useSortParams<T extends string>(defaultKey: T) {
  const [searchParams, setSearchParams] = useSearchParams();

  const raw = searchParams.get("sortBy");
  const sortBy: T = (raw as T) ?? defaultKey;
  const sortDir: SortDir = searchParams.get("sortDir") === "desc" ? "desc" : "asc";

  const setSort = (key: T) => {
    setSearchParams((prev) => {
      if (prev.get("sortBy") === key) {
        prev.set("sortDir", prev.get("sortDir") === "asc" ? "desc" : "asc");
      } else {
        prev.set("sortBy", key);
        prev.set("sortDir", "asc");
      }
      prev.set("page", "1");
      return prev;
    });
  };

  return { sortBy, sortDir, setSort };
}
